export default __webpack_public_path__ + "static/media/raspberryicon.38d7d5e1.png";